import { useMemo } from 'react';
import hubHttpClient from 'hub-http/clients/apiClient';
import contentOutputs from '../editorCapabilities/ContentOutputTypes';
import * as KnowledgeArticlesApi from '../commands/knowledgeArticles/draft-content-transplant-ka/KnowledgeArticlesApi';
import transformArticlesData from '../commands/knowledgeArticles/draft-content-transplant-ka/transformArticlesData';
import KnowledgePopoverEmptyState from '../commands/knowledgeArticles/draft-content-transplant-ka/KnowledgePopoverEmptyState';
import KnowledgePopoverErrorState from '../commands/knowledgeArticles/draft-content-transplant-ka/KnowledgePopoverErrorState';
import MultiKBs from '../commands/knowledgeArticles/MultiKBs';
import { getKnowledgeUrl } from '../utils/manageLinks';
import TypeaheadInserterRenderer from './TypeaheadInserterRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
export default function KnowledgeArticleRenderer({
  onInsert,
  onDismiss,
  portalId,
  useMultipleKBs,
  onSearchAllKBs,
  onSelectKB,
  onSearchKB,
  onClickManage,
  onInsertContent,
  outputType = contentOutputs.RENDERED,
  apiClient = hubHttpClient
}) {
  const apiFunctions = useMemo(() => KnowledgeArticlesApi.defaultApiWrapper(apiClient), [apiClient]);
  if (useMultipleKBs) {
    return /*#__PURE__*/_jsx(MultiKBs, {
      onClickBack: onDismiss,
      onSelectArticle: onInsert,
      onSearchAllKBs: onSearchAllKBs,
      onSelectKB: onSelectKB,
      portalId: portalId
    });
  }
  return /*#__PURE__*/_jsx(TypeaheadInserterRenderer, {
    onInsert: onInsert,
    onDismiss: onDismiss,
    portalId: portalId,
    search: apiFunctions.searchArticles,
    fetchRenderedContent: apiFunctions.fetchRenderedContent,
    transformData: transformArticlesData,
    outputType: outputType,
    EmptyState: KnowledgePopoverEmptyState,
    ErrorState: KnowledgePopoverErrorState,
    searchPlaceholder: "hubspot-prosemirror.knowledgeBase.search.placeholder",
    titleMessage: "hubspot-prosemirror.insertMenu.knowledgeArticle",
    manageUrl: getKnowledgeUrl(portalId),
    contentKey: "kbArticles",
    onClickManageButton: onClickManage,
    onSearchChange: onSearchKB,
    onTrackSelection: onInsertContent ? () => onInsertContent({
      fromPopover: true
    }) : undefined
  });
}